// @flow
export { default } from './FakeEventCard';



// WEBPACK FOOTER //
// ./src/components/common/FakeEventCard/index.js